import * as React from 'react';
import { ICountrysidePromoItem } from '@cian/api-models/offer-card/v1/get-offer-data';
import { IPromotionsAnalyticsData } from '../../types/tracking';

import * as styles from './PromotionsBlock.css';
import { PromotionIcon } from '../PromotionIcon';

export interface IPromotionsBlockProps {
  promotions: ICountrysidePromoItem[];
  villageUrl: string;
  analyticsData: IPromotionsAnalyticsData;
}

interface IPromotionBlockState {
  showTooltipIndex: number;
}

export class PromotionsBlock extends React.Component<IPromotionsBlockProps, IPromotionBlockState> {
  public state = {
    showTooltipIndex: 0,
  };

  public render() {
    const { promotions, villageUrl, analyticsData } = this.props;
    const { showTooltipIndex } = this.state;

    if (promotions.length === 0) {
      return null;
    }

    return (
      <div className={styles['container']}>
        {
          promotions.map((item, index) => {
            if (item.label.length > 35) {
              return null;
            }

            return (
              <PromotionIcon
                key={index}
                href={villageUrl}
                itemIndex={index}
                showTooltip={showTooltipIndex === index}
                item={item}
                analyticsData={analyticsData}
                onMouseEnter={this.onMouseEnter}
                onMouseLeave={this.onMouseLeave}
              />
            );
          })
        }
      </div>
    );
  }

  private onMouseEnter = (index: number) => {
    this.setState({
      showTooltipIndex: index,
    });
  }

  private onMouseLeave = () => {
    this.setState({
      showTooltipIndex: 0,
    });
  }
}
